import script from "./sticky-banner.vue?vue&type=script&lang=js"
export * from "./sticky-banner.vue?vue&type=script&lang=js"

import "./sticky-banner.vue?vue&type=style&index=0&id=04a60350&lang=scss"

const __exports__ = script;

export default __exports__